const initialState = {
  bids: {},
  bidsPerListing: {}
}

export default function bids (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  switch (action.type) {
    case 'BID_GET_SUCCESS': {
      const existingBid = state.bids[action.bid.uuid]
      if (existingBid && action.timestamp < existingBid.timestamp) {
        return state
      }

      const listingUuid = action.bid.listingUuid
      const existingList = (state.bidsPerListing || {})[listingUuid] || []
      const nextList = existingBid
        ? existingList
        : [action.bid.uuid, ...existingList]

      return {
        ...state,
        bids: { ...state.bids, [action.bid.uuid]: { ...action.bid, timestamp: action.timestamp } },
        bidsPerListing: { ...state.bidsPerListing, [listingUuid]: nextList }
      }
    }

    case 'BIDS_GET_SUCCESS': {
      const grouped = {}
      for (const uuid in action.bids) {
        const listingUuid = action.bids[uuid].listingUuid
        const list = grouped[listingUuid] || (grouped[listingUuid] = [])
        list.push(action.bids[uuid])
      }
      const indexed = {}
      for (const listingUuid in grouped) {
        indexed[listingUuid] = grouped[listingUuid].sort((a, b) => b.placedAt - a.placedAt).map(b => b.uuid)
      }

      return {
        ...state,
        bids: { ...state.bids, ...action.bids },
        bidsPerListing: { ...(state.bidsPerListing || {}), ...indexed }
      }
    }

    default:
      return state
  }
}
